module.exports = __webpack_public_path__ + "static/media/contact-icon.bdf60b7d.svg";